import React from 'react';
import { Link } from 'react-router-dom';

const QuoteSection: React.FC = () => {
  return (
    <section
      className="quote-layout bg-position position-relative"
      style={{ backgroundImage: "url('/assets/img/quote/quote-bg-1-1.jpg')" }}
    >
      <div className="overlay"></div>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 mx-auto">
            <div className="quote-block text-center">
              <img src="/assets/img/quote/quote-vec-1-1.svg" alt="quote vector" className="quote-icon" />
              <h2 className="quote-title">get free quote</h2>
              <div className="quote-btns">
                <Link to="/shop" className="vs-btn style2">shop now</Link>
                <a className="vs-btn style3" href="tel:+88017673989722">
                  <i><img src="/assets/img/icons/vs-icon-headphone-1.svg" alt="vs-icon" /></i>
                  make a call
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuoteSection;
